import React from "react";
import Banner from "./Components/Banner";
import Description from "./Components/Description";
import info from "./Data";
import file from "./../../../components/Data/dataStatic";
import "./Perfil.scss";

export default function Perfil(props) {
  const data = info[0][props.match.params.id];
  const fileJson = file[0][props.match.params.id];
  function SetRow({ name, index }) {
    var random = Math.floor(Math.random() * (3 - 1 + 1) + 1);
    return (
      <div className={`dv_${random}`}>
        <div key={index} className="content_masonry">
          <span className="sub_content">
            <img src={name} alt="" />
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="container content_proyect">
      <div className="row">
        <div className="col-12 col-md-6">
          <Banner imagen={data.banner} />
        </div>
        <div className="col-12 col-md-6">
          <Description {...data} />
        </div>
      </div>
      <div className="dv_masonry">
        {fileJson &&
          fileJson.map((item, index) => (
            <SetRow name={item?.name} index={index} />
          ))}
      </div>
    </div>
  );
}
